import { createSlice } from '@reduxjs/toolkit';

const getInitialVersion = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    const saved = window.localStorage.getItem('im_ui_version');
    if (saved === 'v1' || saved === 'v2') {
      return saved;
    }
  }
  return 'v2'; // Default to modern v2 experience
};

const initialState = {
  version: getInitialVersion(),
};

export const uiVersionSlice = createSlice({
  name: 'uiVersion',
  initialState,
  reducers: {
    setUiVersion: (state, action) => {
      const newVersion = action.payload === 'v1' ? 'v1' : 'v2';
      state.version = newVersion;
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem('im_ui_version', newVersion);
      }
    },
    toggleUiVersion: (state) => {
      const nextVersion = state.version === 'v2' ? 'v1' : 'v2';
      state.version = nextVersion;
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem('im_ui_version', nextVersion);
      }
    },
  },
});

export const { setUiVersion, toggleUiVersion } = uiVersionSlice.actions;

export default uiVersionSlice.reducer;
